var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSecond = function SvgSecond(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E0F8F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5308 14.2143C18.5332 14.2143 17.5731 14.5929 16.8681 15.2643L15.5367 16.5357C15.1842 16.8714 14.6142 16.8714 14.2654 16.5357C13.9166 16.2 13.9129 15.6571 14.2654 15.325L15.5968 14.0536C16.6393 13.0571 18.0569 12.5 19.5308 12.5H19.8046C22.7298 12.5 25.0999 14.7571 25.0999 17.5429C25.0999 18.9393 24.4924 20.2714 23.4236 21.225L17.1794 26.7857H25.0999C25.5987 26.7857 26 27.1679 26 27.6429C26 28.1179 25.5987 28.5 25.0999 28.5H14.8992C14.5279 28.5 14.1979 28.2857 14.0629 27.9571C13.9279 27.6286 14.0141 27.2571 14.2842 27.0179L22.1935 19.9714C22.8985 19.3429 23.2998 18.4643 23.2998 17.5429C23.2998 15.7036 21.7359 14.2143 19.8046 14.2143H19.5308Z",
    fill: "#01878E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSecond, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/second.37b997f7.svg";
export { ForwardRef as ReactComponent };